import { render, staticRenderFns } from "./MostViewed.vue?vue&type=template&id=17afa9f4&scoped=true&"
import script from "./MostViewed.vue?vue&type=script&lang=js&"
export * from "./MostViewed.vue?vue&type=script&lang=js&"
import style0 from "./MostViewed.vue?vue&type=style&index=0&id=17afa9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17afa9f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
